export class DutyTaxRequest {
    currency: string;
    items: DutyTaxItem[];
    landed_cost: string;
    sale_type: string;
    ship_from_country: string;
    ship_to: DutyTaxShipTo;
    shipping: DutyTaxShipping;

    constructor() {
        this.items = [new DutyTaxItem()];
        this.ship_to = new DutyTaxShipTo();
        this.shipping = new DutyTaxShipping();
    }
}

export class DutyTaxItem {
    id: string
    amount: number
    brand: string
    category: string
    color: object
    country_of_origin: string
    description_customs: object
    description_retail: string
    detail: string
    dimensions: DutyTaxDimensions
    hs_code: string
    image_url: string
    quantity: number
    upc_code: string
    weight: number
    weight_unit: string

    constructor() {
        this.dimensions = new DutyTaxDimensions();
    }
}

export class DutyTaxDimensions {
    height: number
    length: number
    unit: string
    width: number
}

export class DutyTaxShipTo {
    city: string
    country: string
    postal_code: string
    state: string
}

export class DutyTaxShipping {
    amount: number
    service_level: string
}



// WEBPACK FOOTER //
// ./app/objects/zonos/dutyTaxRequest.ts